import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["Incident"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getIncident: build.query<GetIncidentApiResponse, GetIncidentApiArg>({
        query: () => ({ url: `/Incident` }),
        providesTags: ["Incident"],
      }),
      postIncident: build.mutation<PostIncidentApiResponse, PostIncidentApiArg>(
        {
          query: (queryArg) => ({
            url: `/Incident`,
            method: "POST",
            body: queryArg,
          }),
          invalidatesTags: ["Incident"],
        }
      ),
      putIncidentById: build.mutation<
        PutIncidentByIdApiResponse,
        PutIncidentByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Incident/${queryArg.id}`,
          method: "PUT",
          body: queryArg.incidentDto,
        }),
        invalidatesTags: ["Incident"],
      }),
      deleteIncidentById: build.mutation<
        DeleteIncidentByIdApiResponse,
        DeleteIncidentByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Incident/${queryArg}`,
          method: "DELETE",
        }),
        invalidatesTags: ["Incident"],
      }),
      putIncidentByIdGetGraphAssignment: build.mutation<
        PutIncidentByIdGetGraphAssignmentApiResponse,
        PutIncidentByIdGetGraphAssignmentApiArg
      >({
        query: (queryArg) => ({
          url: `/Incident/${queryArg.id}/GetGraphAssignment`,
          method: "PUT",
          body: queryArg.body,
        }),
        invalidatesTags: ["Incident"],
      }),
      getIncidentByIdGetGraphAssignment: build.query<
        GetIncidentByIdGetGraphAssignmentApiResponse,
        GetIncidentByIdGetGraphAssignmentApiArg
      >({
        query: (queryArg) => ({
          url: `/Incident/${queryArg}/GetGraphAssignment`,
        }),
        providesTags: ["Incident"],
      }),
      getIncidentByIdAttachment: build.query<
        GetIncidentByIdAttachmentApiResponse,
        GetIncidentByIdAttachmentApiArg
      >({
        query: (queryArg) => ({ url: `/Incident/${queryArg}/Attachment` }),
        providesTags: ["Incident"],
      }),
      getIncidentAnhangById: build.query<
        GetIncidentAnhangByIdApiResponse,
        GetIncidentAnhangByIdApiArg
      >({
        query: (queryArg) => ({ url: `/Incident/Anhang/${queryArg}` }),
        providesTags: ["Incident"],
      }),
      deleteIncidentAnhangById: build.mutation<
        DeleteIncidentAnhangByIdApiResponse,
        DeleteIncidentAnhangByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Incident/Anhang/${queryArg}`,
          method: "DELETE",
        }),
        invalidatesTags: ["Incident"],
      }),
      postIncidentByIdAnhang: build.mutation<
        PostIncidentByIdAnhangApiResponse,
        PostIncidentByIdAnhangApiArg
      >({
        query: (queryArg) => ({
          url: `/Incident/${queryArg.id}/Anhang`,
          method: "POST",
          params: { fileName: queryArg.fileName },
        }),
        invalidatesTags: ["Incident"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as incidentApi };
export type GetIncidentApiResponse = /** status 200 OK */ IncidentDto[];
export type GetIncidentApiArg = void;
export type PostIncidentApiResponse = /** status 201 Created */ number;
export type PostIncidentApiArg = IncidentDto;
export type PutIncidentByIdApiResponse = /** status 200 OK */ number;
export type PutIncidentByIdApiArg = {
  id: number;
  incidentDto: IncidentDto;
};
export type DeleteIncidentByIdApiResponse = unknown;
export type DeleteIncidentByIdApiArg = number;
export type PutIncidentByIdGetGraphAssignmentApiResponse =
  /** status 200 OK */ void;
export type PutIncidentByIdGetGraphAssignmentApiArg = {
  id: number;
  body: number[];
};
export type GetIncidentByIdGetGraphAssignmentApiResponse =
  /** status 200 OK */ GraphAssignmentDto[];
export type GetIncidentByIdGetGraphAssignmentApiArg = number;
export type GetIncidentByIdAttachmentApiResponse =
  /** status 200 OK */ IncidentAttachmentDto[];
export type GetIncidentByIdAttachmentApiArg = number;
export type GetIncidentAnhangByIdApiResponse = unknown;
export type GetIncidentAnhangByIdApiArg = number;
export type DeleteIncidentAnhangByIdApiResponse = unknown;
export type DeleteIncidentAnhangByIdApiArg = number;
export type PostIncidentByIdAnhangApiResponse = /** status 201 Created */ void;
export type PostIncidentByIdAnhangApiArg = {
  fileName: string;
  id: number;
};
export type IncidentDto = {
  id: number;
  name: string;
  measuringPoint: string;
  start: string;
  end: string;
  comment?: string | null;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type GraphAssignmentDto = {
  configuration: number;
  incident: number;
};
export type IncidentAttachmentDto = {
  id: number;
  name: string;
  incident: number;
};
export const {
  useGetIncidentQuery,
  useLazyGetIncidentQuery,
  usePostIncidentMutation,
  usePutIncidentByIdMutation,
  useDeleteIncidentByIdMutation,
  usePutIncidentByIdGetGraphAssignmentMutation,
  useGetIncidentByIdGetGraphAssignmentQuery,
  useLazyGetIncidentByIdGetGraphAssignmentQuery,
  useGetIncidentByIdAttachmentQuery,
  useLazyGetIncidentByIdAttachmentQuery,
  useGetIncidentAnhangByIdQuery,
  useLazyGetIncidentAnhangByIdQuery,
  useDeleteIncidentAnhangByIdMutation,
  usePostIncidentByIdAnhangMutation,
} = injectedRtkApi;
